import React from "react";
const MessageIcon = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.1h-.803A2.75 2.75 0 0 1 7.25 7.6H5.5v1c0 .827.673 1.5 1.5 1.5h1.146l1.427 1.427A.25.25 0 0 0 10 11.35V10.1h.5c.827 0 1.5-.673 1.5-1.5v-1c0-.827-.673-1.5-1.5-1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4.85v-2C9.5 1.61 8.49.6 7.25.6h-5C1.01.6 0 1.61 0 2.85v2C0 6.09 1.01 7.1 2.25 7.1h.25v1.75c0 .222.27.334.427.177L4.854 7.1H7.25c1.24 0 2.25-1.01 2.25-2.25Z",
    fill: "#fff"
  }));
};
export default MessageIcon;